import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "antd/dist/antd.css";
import "./assets/css/material-dashboard-react.css?v=1.9.0";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import * as serviceWorker from "./serviceWorker";
import store from "./store/reducers/rootReducer";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

// create address Variable
React.env = {
  address: "333 hig ratan Lal nagar, Kanpur, India",
  address1: "Address 333 hig <br>ratan Lal nagar kanpur",
  email: "Harshdeepbhatia6841@gmail.com",
  mobile: "7408505301",
};

// Fetch API data when app starts
fetch("https://travelpick-2.onrender.com")
  .then((response) => response.json())
  .then((data) => {
    console.log("API Data:", data);
    // You can store this data in Redux store or React context if needed
  })
  .catch((error) => {
    console.error("Error fetching API data:", error);
  });

Sentry.init({
  dsn:
    "https://28de36421de74f0a8dbde1f4d2506e90@o1005855.ingest.sentry.io/5966337",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
